import Vue from 'vue'
import Vuex from 'vuex'
import client from './client/client.module'
import user from './user/user.module'
import file from './file/file.module'
import medium from './medium/medium.module'
import network from './network/network.module'
import holidayset from './holidayset/holidayset.module'
import device from './device/device.module'
import request from './request/request.module'
import privilege from './privilege/privilege.module'
import role from './role/role.module'
import error from './error/error.module'
import clipboard from './clipboard/clipboard.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: true,
  modules: {
    Client: client,
    User: user,
    File: file,
    Medium: medium,
    Network: network,
    Holidayset: holidayset,
    Device: device,
    Request: request,
    Privilege: privilege,
    Role: role,
    Error: error,
    Clipboard: clipboard
  },
  state: {
    locale: 'pl'
  }
})

export default store



//////////////////
// WEBPACK FOOTER
// ./state/index.js
// module id = null
// module chunks = 